import React, { useState } from "react";
import { Server } from "lucide-react";
import { api } from "../../../lib/api";
import { isCanceled, useLatestRequest } from "../../../lib/useLatest";
import { PageHeader } from "../../../components/PageHeader";
import { MonError, MonToolbar } from "./MonToolbar";
import { InstanceGrid } from "./InstanceCard";
import { SystemChart } from "./SystemChart";
import { monErr, refreshMs, useAutoRefresh, useMonPrefs } from "./monUtil";

export default function MonitoringSystem() {
  const prefs = useMonPrefs(); const next = useLatestRequest();
  const [data, setData] = useState(null); const [inst, setInst] = useState(""); const [err, setErr] = useState(""); const [loading, setLoading] = useState(false);
  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/platform/monitoring/system", { params: { window: prefs.win }, signal: next() }); setData(r.data); setErr(""); return true; }
    catch (e) { if (!isCanceled(e)) setErr(monErr(e)); } finally { setLoading(false); }
  };
  const { refresh, at } = useAutoRefresh(load, prefs.auto, [prefs.win], refreshMs(prefs.win));
  const names = [...new Set([...(data?.instances || []).map((s) => s.instance), ...(data?.series || []).map((s) => s.instance)])];
  const active = names.includes(inst) ? inst : names[0] || "";
  const series = data ? data.series?.find((s) => s.instance === active) || { instance: active, points: [] } : null;
  return (
    <div data-testid="platform-monitoring-system">
      <PageHeader icon={Server} title="Sistem" description="CPU, RAM & disk per instance (batas container). Nilai per titik = rata-rata snapshot dalam bucket.">
        <MonToolbar prefs={prefs} onRefresh={refresh} loading={loading} at={at} />
      </PageHeader>
      <MonError msg={err} />
      <InstanceGrid items={data ? data.instances || [] : err ? [] : null} active={active} onPick={setInst} />
      <div className="aivora-card mt-6 p-5">
        <div className="mb-4 flex flex-wrap items-center gap-3">
          <p className="flex-1 text-sm font-black text-slate-900">Grafik CPU / RAM / Disk</p>
          {names.length > 0 && (
            <select value={active} onChange={(e) => setInst(e.target.value)} className="input-ui w-auto font-mono text-xs" data-testid="mon-system-instance">
              {names.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          )}
        </div>
        {(data && !names.length) || (err && !data) ? <p className="py-10 text-center text-sm text-slate-400" data-testid="mon-system-empty">Belum ada data sistem.</p> : <SystemChart series={series} win={prefs.win} step={data?.step_min || 1} />}
      </div>
    </div>
  );
}
